module.exports = __webpack_public_path__ + "assets/point.7721bc7d.svg";